import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import user from "assets/images/menOne.jpg";
import { Avatar } from "@material-ui/core";
import DatePicker from "react-date-picker";
import { VscCalendar } from "react-icons/vsc";
import { RiDeleteBin5Line } from "react-icons/ri";
import "./header.scss"; import { FaUserAlt } from "react-icons/fa";

const NotifyModal = (props) => {
  const [value, onChange] = useState(new Date());
  const [modalArray, setModalArray] = useState([
    {
      title: "New Appointment",
      date: "Mar 26, 2020 at 10:24AM",
      content: "New Appointment has been booked by Patient Mr.John Doe",
      time: "10:30 - 11:00 AM",
      isUpcomming: false
    },
    {
      title: " Appointment",
      date: "Mar 26, 2020 at 10:24AM",
      content: "New Appointment has been booked by Patient Mr.John Doe",
      time: "10:30 - 11:00 AM",
      isUpcomming: false
    },
    {
      title: "Profile Verified",
      date: "Mar 26, 2020 at 10:24AM",
      content: "New Appointment has been booked by Patient Mr.John Doe",
      time: "10:30 - 11:00 AM",
      isUpcomming: false
    },
    {
      title: "Title",
      date: "Mar 26, 2020 at 10:24AM",
      content: "New Appointment has been booked by Patient Mr.John Doe",
      time: "10:30 - 11:00 AM",
      isUpcomming: false
    },
    {
      title: "Profile Update",
      date: "Mar 26, 2020 at 10:24AM",
      content: "New Appointment has been booked by Patient Mr.John Doe",
      time: "10:30 - 11:00 AM",
      isUpcomming: false
    },
  ])

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="notify-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="notify-body">
        <div>
          <div className="notify-card">
            <div className="notify-avatar-parent">
              <div className="notify-avatar"><FaUserAlt /></div>
              <div className="notify-title">
                <label className="notify-title-label">New Appointment</label>
                <p className="notify-para">Mar 26, 2020 at 10:24AM</p>
                <label className="notify-content">New Appointment has been booked by Patient Mr.John Doe</label>
                <div className="notify-footer">
                  <div><button className="red-btn">Reject</button></div>
                  <div><button className="green-btn">Accept</button></div>
                </div>
              </div>
            </div>
            <div>
              <label className="notify-view">View</label>
            </div>
          </div>
          {
            React.Children.toArray(
              modalArray.map((val) => (
                <div className="notify-card">
                  <div className="notify-avatar-parent">
                    <div className="notify-avatar"><FaUserAlt /></div>
                    <div className="notify-title">
                      <label className="notify-title-label">{val.title}</label>
                      <p className="notify-para">{val.date}</p>
                      <label className="notify-content">{val.content}</label>
                    </div>
                  </div>
                  <div>
                    <label className="notify-view">View</label>
                  </div>
                </div>
              ))
            )}
        </div>

      </Modal.Body>
    </Modal>
  );
};
export default NotifyModal;
